<template>
  <page-content></page-content>
</template>

<script>
/*guides component from view directory by router*/

// components
import PageContent from './components/PageContent.vue';

export default {
  name: 'Guides',
  components: {
    PageContent
  },
}
</script>
